import { required } from '@/commons/utils/Rules';
import baseFormDocumentacion from "@/commons/forms/PzBaseForm";
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzIdentityDocument from "@/commons/forms/Fields/PzIdentityDocument";
export default {
  name: 'PzContinuarDocForm',
  components: {
    PzIdentityDocument: PzIdentityDocument,
    PzFormFlujo: PzFormFlujo
  },
  mixins: [baseFormDocumentacion],
  data: function data() {
    return {
      formulariodocumentacion: {
        numero_solicitud: '',
        numero_documento: {}
      },
      rules_formulariodocumentacion: {
        numero_solicitud: [required('')],
        'numero_documento.document': [required('')],
        'numero_documento.number': [required('')]
      }
    };
  },
  created: function created() {}
};